import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import type { ComponentProps } from 'react';

/**
 * Toolbar glyph for the "pan" tool — a filled open-palm silhouette,
 * drawn as a single closed path so `fill` produces one solid shape
 * (four finger bumps plus the palm arch). `currentColor` lets the Ant
 * Design button re-colour the glyph on active/default states.
 */
function HandSvg(props: Partial<CustomIconComponentProps>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        d="M4.8 6.6 C4.8 5.9 5.4 5.3 6.1 5.3 C6.8 5.3 7.4 5.9 7.4 6.6
           L7.4 10.5
           L8.2 10.5
           L8.2 4.8 C8.2 4.1 8.8 3.5 9.5 3.5 C10.2 3.5 10.8 4.1 10.8 4.8
           L10.8 10.5
           L11.6 10.5
           L11.6 3.9 C11.6 3.2 12.2 2.6 12.9 2.6 C13.6 2.6 14.2 3.2 14.2 3.9
           L14.2 10.5
           L15 10.5
           L15 5.1 C15 4.4 15.6 3.8 16.3 3.8 C17 3.8 17.6 4.4 17.6 5.1
           L17.6 11.3
           L18.4 11.3
           L18.4 9 C18.4 8.3 19 7.7 19.7 7.7 C20.4 7.7 21 8.3 21 9
           L21 14.6 C21 18.2 18.1 21.1 14.5 21.1
           L11.6 21.1 C7.9 21.1 4.8 18 4.8 14.3 Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function HandGlyph(props: ComponentProps<typeof Icon>) {
  return <Icon component={HandSvg} {...props} />;
}
